import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AlertRuleIcon = props => (
  <Icon viewBox="0 0 2480 2475" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-1072 0)">
      <g>
        <g>
          <g>
            <path
              d="M175.62 2195.24 1580.58 2195.24 1580.58 2283.05 175.62 2283.05Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(-1 1.22653e-16 -1.22465e-16 -1.00154 2657.99 4318.4)"
            />
            <path
              d="M439.049 2546.48 1844.01 2546.48 1844.01 2634.29 439.049 2634.29Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(-1 1.22653e-16 -1.22465e-16 -1.00154 3184.85 5021.96)"
            />
            <path
              d="M1229.34 1317.15 2897.72 1317.15 2897.72 1404.96 1229.34 1404.96Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(6.12323e-17 1.00154 -1 6.13263e-17 4326.37 -870.328)"
            />
            <path
              d="M-351.239 1317.15 1317.15 1317.15 1317.15 1404.96-351.239 1404.96Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(6.12323e-17 1.00154 -1 6.13263e-17 2745.8 712.675)"
            />
            <path
              d="M2107.44 2195.24 2019.63 2195.24 2019.63 2370.86C2019.63 2467.86 1941 2546.48 1844.01 2546.48L1756.2 2546.48 1756.2 2634.29 1844.01 2634.29C1989.49 2634.29 2107.44 2516.35 2107.44 2370.86Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.00154 901.792 -166.771)"
            />
            <path
              d="M1492.77 2283.05 1580.58 2283.05 1580.58 2370.86C1580.58 2467.86 1659.2 2546.48 1756.2 2546.48L1844.01 2546.48 1844.01 2634.29 1756.2 2634.29C1610.71 2634.29 1492.77 2516.35 1492.77 2370.86Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.00154 901.792 -166.771)"
            />
            <path
              d="M175.62 2283.05 263.429 2283.05 263.429 2370.86C263.429 2467.86 342.057 2546.48 439.049 2546.48L526.859 2546.48 526.859 2634.29 439.049 2634.29C293.561 2634.29 175.62 2516.35 175.62 2370.86Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.00154 901.792 -166.771)"
            />
            <path
              d="M2107.44 526.859 2634.29 526.859 2634.29 614.669 2107.44 614.669Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.00154 901.792 -166.771)"
            />
            <path
              d="M702.478 175.62 2370.86 175.62 2370.86 263.429 702.478 263.429Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.00154 901.792 -166.771)"
            />
            <path
              d="M439.049 526.859 526.859 526.859 526.859 439.049C526.859 342.057 605.486 263.429 702.478 263.429L790.288 263.429 790.288 175.62 702.478 175.62C556.99 175.62 439.049 293.561 439.049 439.049Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.00154 901.792 -166.771)"
            />
            <path
              d="M2019.63 526.859 2107.44 526.859 2107.44 439.049C2107.44 342.057 2186.06 263.429 2283.05 263.429L2370.86 263.429 2370.86 175.62 2283.05 175.62C2137.57 175.62 2019.63 293.561 2019.63 439.049Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.00154 901.792 -166.771)"
            />
            <path
              d="M2634.29 526.859 2546.48 526.859 2546.48 439.049C2546.48 342.057 2467.86 263.429 2370.86 263.429L2283.05 263.429 2283.05 175.62 2370.86 175.62C2516.35 175.62 2634.29 293.561 2634.29 439.049Z"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.00154 901.792 -166.771)"
            />
            <path
              d="M577.5 763.984C560.887 763.984 547.422 777.45 547.422 794.062 547.422 810.675 560.887 824.141 577.5 824.141 594.113 824.141 607.578 810.675 607.578 794.062 607.578 777.45 594.113 763.984 577.5 763.984ZM577.5 673.75 577.529 673.75C590.811 673.74 601.572 662.97 601.562 649.688L601.562 457.188C601.562 443.899 590.787 433.125 577.5 433.125 564.213 433.125 553.438 443.899 553.438 457.188L553.438 649.712C553.447 662.999 564.218 673.76 577.5 673.75ZM1093.06 844.445 700.917 167.404C688.443 145.89 670.559 128.008 649.047 115.537 580.888 76.0235 493.604 99.2429 454.086 167.404L61.895 844.584C49.3031 866.322 42.6734 890.996 42.6763 916.117 42.691 994.903 106.569 1058.76 185.356 1058.75L969.502 1058.75C994.643 1058.75 1019.34 1052.12 1041.1 1039.52 1109.31 999.999 1132.58 912.662 1093.06 844.445ZM969.507 1010.62 185.356 1010.62C168.755 1010.62 152.45 1006.24 138.077 997.925 92.8543 971.774 77.3864 913.918 103.535 868.695L495.726 191.56C512.478 162.243 543.731 144.228 577.5 144.422 611.269 144.228 642.522 162.243 659.274 191.56L1051.42 868.598C1059.77 883.017 1064.16 899.379 1064.15 916.035 1064.14 968.294 1021.76 1010.64 969.507 1010.62Z"
              stroke="currentColor"
              strokeWidth="10.3125"
              strokeLinecap="butt"
              strokeLinejoin="miter"
              strokeMiterlimit="4"
              strokeOpacity="1"
              fill="currentColor"
              fillRule="nonzero"
              fillOpacity="1"
              transform="matrix(1 0 0 1.00087 1619 463)"
            />
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
